import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

//constants
import defaults from '../i18n-defaults.json';
import { i18nKeys } from '../i18n-keys';

export const dataDictToI18nVariablesObject = ({ data = {}, plural }: { data?: any; plural?: boolean }) => {
  // this is in order for us to use "plural" prop directly and bypass "count" props of react-intl.
  let count;
  if (data?.count) {
    // if a count props has pass, this is something react-intl knows how to work with and pluralize it
    count = data?.count;
  } else if (plural) {
    // if we pass "plural" we will set count to 2 to render a plural version of the string.
    count = 2;
  } else {
    // no need for plural in this case.
    count = 1;
  }
  return { count, b: (chunks: string) => <b>{chunks}</b>, ...data };
};

export const I18nText = ({
  children,
  id,
  data = {},
  plural,
  capitalizeFirstLetter,
  capitalize,
  uppercase,
  lowercase,
  defaultMessage,
  renderOnlyIfExists,
}: {
  children?: any;
  id?: string;
  data?: any;
  plural?: boolean;
  capitalizeFirstLetter?: boolean;
  capitalize?: boolean;
  uppercase?: boolean;
  lowercase?: boolean;
  defaultMessage?: any;
  renderOnlyIfExists?: boolean;
}): React.JSX.Element | null => {
  const variablesObject = dataDictToI18nVariablesObject({ data, plural });
  const intl = useIntl();

  if (!id) {
    return null;
  }

  // if renderOnlyIfExists is true and the message does not exist in the i18n file (and no default message provided), return null
  if (renderOnlyIfExists && !intl?.messages[id] && !defaultMessage) {
    return null;
  }

  const Component = (
    <FormattedMessage
      id={id}
      defaultMessage={defaultMessage || defaults[id as keyof typeof i18nKeys]}
      values={variablesObject}
    >
      {children}
    </FormattedMessage>
  );

  if (capitalize) {
    return <span className={'box-i18n-container text-capitalize'}>{Component}</span>;
  }

  if (capitalizeFirstLetter) {
    return <span className={'box-i18n-container capitalize-first-letter'}>{Component}</span>;
  }

  if (uppercase) {
    return <span className={'box-i18n-container text-uppercase'}>{Component}</span>;
  }

  if (lowercase) {
    return <span className={'box-i18n-container text-lowercase'}>{Component}</span>;
  }

  return Component;
};
